export const theme = {
  radio: {
    valid: {
      colors: ["primary"],
    },
    styles: {
      colors: {
        primary: {
          color: "text-primary",
          border: "checked:border-primary",
          before: "checked:before:bg-primary",
        },
      },
    },
  },
  checkbox: {
    valid: {
      colors: ["primary"],
    },
    styles: {
      colors: {
        primary: {
          background: "checked:bg-primary",
          border: "checked:border-primary",
          before: "checked:before:bg-primary",
        },
      },
    },
  },
  input: {
    valid: {
      colors: ["primary"],
      sizes: ["xl"],
    },
    styles: {
      variants: {
        outlined: {
          sizes: {
            xl: {
              container: {
                height: "h-14",
              },
              input: {
                fontSize: "text-sm",
                px: "px-3",
                py: "py-2.5",
                borderRadius: "rounded-[8px]",
              },
              label: {
                lineHeight: "peer-placeholder-shown:leading-[4.75]",
              },
              icon: {
                width: "w-6",
                height: "h-6",
              },
            },
          },
          colors: {
            input: {
              primary: {
                borderColor: "border-blue-gray-200",
                borderColorFocused: "focus:border-primary",
              },
            },
            label: {
              primary: {
                color: "text-blue-gray-400  peer-focus:text-primary",
                before:
                  "before:border-blue-gray-400 peer-focus:before:!border-primary",
                after:
                  "after:border-blue-gray-400 peer-focus:after:!border-primary",
              },
            },
          },
        },
      },
    },
  },

  select: {
    valid: {
      colors: ["primary"],
    },
    styles: {
      variants: {
        outlined: {
          colors: {
            select: {
              primary: {
                close: {
                  borderColor: "border-primary",
                },
                open: {
                  borderColor: "border-primary",
                },
                withValue: {
                  borderColor: "border-primary",
                },
              },
            },
            label: {
              primary: {
                close: {
                  borderColor: "border-primary",
                },
                open: {
                  borderColor: "border-primary",
                },
                withValue: {
                  borderColor: "border-primary",
                },
              },
            },
          },
        },
        standard: {
          colors: {
            select: {
              primary: {
                close: {
                  borderColor: "border-primary",
                },
                open: {
                  borderColor: "border-primary",
                },
                withValue: {
                  borderColor: "border-primary",
                },
              },
            },
            label: {
              primary: {
                close: {
                  borderColor: "border-primary",
                },
                open: {
                  borderColor: "border-primary",
                },
                withValue: {
                  borderColor: "border-primary",
                },
              },
            },
          },
        },
        static: {
          colors: {
            select: {
              primary: {
                close: {
                  borderColor: "border-primary",
                },
                open: {
                  borderColor: "border-primary",
                },
                withValue: {
                  borderColor: "border-primary",
                },
              },
            },
            label: {
              primary: {
                close: {
                  borderColor: "border-primary",
                },
                open: {
                  borderColor: "border-primary",
                },
                withValue: {
                  borderColor: "border-primary",
                },
              },
            },
          },
        },
      },
    },
  },

  switch: {
    valid: {
      colors: ["primary"],
    },
    styles: {
      colors: {
        primary: {
          input: "checked:bg-primary",
          circle: "peer-checked:border-primary",
          before: "peer-checked:before:bg-primary",
        },
      },
    },
  },
  tab: {
    defaultProps: {
      className: "w-full rounded-full ",
      activeClassName: "w-full rounded-full",
      disabled: false,
    },
    styles: {
      base: {
        tab: {
          initial: {
            display: "flex",
            alignItems: "items-center",
            justifyContent: "justify-center",
            textAlign: "text-center",
            width: "w-full",
            height: "h-full",
            position: "relative",
            bg: "bg-transparent",
            py: "py-1",
            px: "px-2",
            color: "text-blue-gray-900",
            fontSmoothing: "antialiased",
            fontFamily: "font-sans",
            fontSize: "text-base",
            fontWeight: "font-normal",
            lineHeight: "leading-relaxed",
            userSelect: "select-none",
            cursor: "cursor-pointer",
          },
          disabled: {
            opacity: "opacity-50",
            cursor: "cursor-not-allowed",
            pointerEvents: "pointer-events-none",
            userSelect: "select-none",
          },
        },
        indicator: {
          position: "absolute",
          inset: "inset-0",
          zIndex: "z-0",
          height: "h-full",
          bg: "bg-primary-200",
          borderRadius: "rounded-full",
          boxShadow: "shadow",
        },
      },
    },
  },
  tabsHeader: {
    defaultProps: {
      className: "",
    },
    styles: {
      base: {
        display: "flex",
        position: "relative",
        bg: "bg-blue-gray-50",
        bgOpacity: "bg-opacity-60",
        borderRadius: "rounded-full",
        p: "p-1",
      },
      horizontal: {
        flexDirection: "flex-row",
      },
      vertical: {
        flexDirection: "flex-col",
      },
    },
  },
  tabsBody: {
    defaultProps: {
      animate: {
        unmount: {},
        mount: {},
      },
      className: "",
    },
    styles: {
      base: {
        display: "block",
        width: "w-full",
        position: "relative",
        bg: "bg-transparent",
        overflow: "overflow-hidden",
      },
    },
  },
};
